import { Injectable } from '@angular/core';
import { Api } from '../services/api';

@Injectable({
  providedIn: 'root'
})
export class NewmemberService {
  mid: number;
  mlid: number;
  mstatus: String;
  declDocumentType : String;
  primaryMemberInfo: any;
  constructor(public api: Api) { }

  setDefault(mid, mlid, status) {
    if (mid == null) {
      this.mid = 0;
    } else {
      this.mid = mid;
    }
    this.mlid = mlid;
    this.mstatus = status;
  }


  getPhoneNoByCardHolder(cid, mid) {
    let body = {"cardHolderNbr": cid, "membershipNbr": mid};
    let seq = this.api.post('member/v1/getPhoneNoByCardholder', body);
    return seq
  }
  

  generateOTP(data) {
    let seq = this.api.post('sms/v1/generateOTP', data);
    return seq
  }

  generateMemberOTP(request) {
    let seq = this.api.post('sms/v1/sendOTPByMembershipNo', request);
    return seq
  }

  validateMembershipNbr(request) {
    let seq = this.api.post('bp/v1/checkMembershipNo', request);
    return seq
  }

  verifyOTP(phnum, otp, id) {
    let seq = this.api.post('sms/v1/validateOTP', { "loginID": id, "otp": otp, "phone": parseInt(phnum) });
    return seq
  }

  verifyOnboardOTP(phnum, otp, id) {
    let seq = this.api.post('sms/v1/verifyOTP', { "loginID": id, "otp": otp, "phone": parseInt(phnum) });
    return seq
  }

  verifyMemberOTP(request) {
    let seq = this.api.post('sms/v1/validateMemberOTP', request);
    return seq
  }

  getExsisting(phnum) {
    let seq = this.api.get('member/v1/getBusinessByPhone/' + phnum);
    return seq
  }

  saveInfoWithOTP(data) {
    let seq = this.api.post('member/v1/saveBasicInfo', { "validId": data.otpId, "firstName": this.toUpperCase(data.firstName), "middleName": this.toUpperCase(data.middleName), "lastName": this.toUpperCase(data.lastName), "maMembershipId": this.mlid?this.mlid:null, "membershipNbr": this.mid?this.mid:null, "phoneNbr": data.phoneNbr, "status": this.mstatus?this.mstatus:"DRAFT", "createdSource": "BESTPRICE", "storeId": data.storeId , "maSourceId": data.maSourceId , "acceptMarketingCall" : data.marketCommunication, "extensionNbr": data.extensionNbr});
    return seq
  }

  
  saveInfo(data) {
    let seq = this.api.post('bp/v1/saveBasicInfo', { "firstName": this.toUpperCase(data.firstName), "middleName": this.toUpperCase(data.middleName), "lastName": this.toUpperCase(data.lastName), "maMembershipId": this.mlid?this.mlid:null, "membershipNbr": this.mid?this.mid:null, "phoneNbr": data.phoneNbr, "status": this.mstatus?this.mstatus:"DRAFT", "createdSource": "BESTPRICE", "storeId": data.storeId, "acceptMarketingCall" : data.marketCommunication, "extensionNbr": data.extensionNbr}, true);
    return seq
  }

  formFill() {
    let seq = this.api.get('master/v1/getOnboardingFormMaster');
    return seq
  }

  getLocationByPincode(pincode) {
    let seq = this.api.get('master/v1/getLocationByPincode/' + pincode);
    return seq
  }

  getCountyListByCity(city) {
    let seq = this.api.get('master/v1/getCountyByCity/' + city);
    return seq
  }

  getCityByState(state) {
    let seq = this.api.get('master/v1/getCitiesByState/' + state);
    return seq
  }

  uploadDoc(files, type, docId) {
    let formData = new FormData();
    let tempArray: any = [];
    for (let file of files) {
      tempArray.push(file);
    }
    
    for (let i = 0; i < tempArray.length; i++) {
      formData.append("file", tempArray[i]);
    }
    formData.append('maMembershipId', this.mlid.toString());
    formData.append('membershipNbr', this.mid.toString());
    formData.append('documentType', type);
    formData.append('documentId', docId.toString());
    let seq = this.api.postFormdata('document/v1/uploadDocuments', formData);
    return seq
  }

  deleteFilebyId(docId, ids?) {
    let body: any;
    if(ids){
      body = { "documentId": docId, "vaultIds": ids };
    } else {
      body = { "documentId": docId, "vaultIds": [0] };
    }
    let seq = this.api.post('bp/v1/removeDocumentsByIds', body, true);
    return seq
  }

  fetchFiles(id) {
    let body = {"documentId": id, "maMembershipId": this.mlid};
    let seq = this.api.post('bp/v1/getDocuments', body, true);
    return seq
  }

  savePhoto(cid, did) {
    let body = {"cardHolderNbr": cid, "documentId": did, "membershipNbr": this.mid };
    let seq = this.api.post('bp/v1/saveMemberPhoto', body, true);
    return seq
  }

  sendCard(cid) {
    let body = {"cardHolderNbr": cid, "membershipNbr": this.mid};
    let seq = this.api.post('bp/v1/sendECard', body, true);
    return seq
  }

  fetchCard(cid, mid) {
    let body = {"cardHolderNbr": cid, "membershipNbr": mid};
    let seq = this.api.post('bp/v1/getCardHolderEcardInfo', body, true);
    return seq
  }
  
  fetchPDFCard(cid, mid, img64) {
    let body = {"cardHolderNbr": cid, "membershipNbr": mid, "ecardBase64": img64};
    let seq = this.api.post('bp/v1/getCardHolderPDFEcardInfo', body, true);
    return seq
  }

  updatePrimaryContactNo(cid, mid) {
    let body = {"cardHolderNbr": cid, "membershipNbr": mid};
    let seq = this.api.post('bp/v1/updateCardHolderPhoneNbr', body, true);
    return seq
  }

  validateGST(no) {
    let body = {"number": this.toUpperCase(no)};
    let seq = this.api.post('member/v1/verifyGST', body);
    return seq
  }

  validateUAN(no) {
    let body = {"number": this.toUpperCase(no)};
    let seq = this.api.post('member/v1/verifyUAN', body);
    return seq
  }

  saveBD(data) {
    var body = { 
      "maMembershipId": this.mlid, 
      "businessLicenseParamsList": [], 
      "businessName": this.toUpperCase(data.businessName), 
      "membershipNbr": this.mid, 
      "ownerNameNotVisible": data.ownerNameNotVisible, 
      "segmentCode": data.segmentCode, 
      "sicCode": data.sicCode, 
      "status": this.mstatus, 
      "taxExemption": data.taxExemption,
      "authorizationDocument": data.authorizationDocument,
      "supportingDocuments": data.supportingDocuments
    }
    for (let ll of data.businessLicenseParamsList) {
      let temp: any = {};
      temp.licenseNumber = this.toUpperCase(ll.licenseNumber);
      temp.licenseType = ll.licenseType;
      temp.documentId = ll.documentId;
      temp.expirationDate = ll.expirationDate;
      temp.stateProvCode = ll.stateProvCode;
      temp.thirdPartyCheck = ll.thirdPartyCheck;
      temp.noOfPages = ll.noOfPages;
      body.businessLicenseParamsList.push(temp);
    } 
    let seq = this.api.post('bp/v1/saveBusinessInfo', body, true);
    return seq
  }

  saveBA(data) {
    let body: any = { 
      "maMembershipId": this.mlid, 
      "businessAddressLine1": this.toUpperCase(data.businessAddressLine1), 
      "businessAddressLine2": this.toUpperCase(data.businessAddressLine2), 
      "businessCityName": data.businessCityName, 
      "businessCountryCode": "IN", 
      "businessCountyName": data.businessCountyName, 
      "businessPostalCode": data.businessPostalCode, 
      "businessStateProvCode": data.businessStateProvCode, 
      "mailingCountryCode": "IN", 
      "mailingCountyName": data.mailingCountyName,  
      "membershipNbr": this.mid, 
      "sameAsBusinessAddress": data.sameAsBusinessAddress, 
      "status": this.mstatus 
    }
    if (!data.sameAsBusinessAddress) {
      body.mailingAddressLine1 = this.toUpperCase(data.mailingAddressLine1);
      body.mailingAddressLine2 = this.toUpperCase(data.mailingAddressLine2);
      body.mailingCityName = data.mailingCityName;
      body.mailingPostalCode = data.mailingPostalCode;
      body.mailingStateProvCode = data.mailingStateProvCode;
      body.mailingCountyName = data.mailingCountyName;
    } else {
      body.mailingAddressLine1 = this.toUpperCase(data.businessAddressLine1);
      body.mailingAddressLine2 = this.toUpperCase(data.businessAddressLine2);
      body.mailingCityName = data.businessCityName;
      body.mailingPostalCode = data.businessPostalCode;
      body.mailingStateProvCode = data.businessStateProvCode;
      body.mailingCountyName = data.businessCountyName;
    }
    let seq = this.api.post('bp/v1/saveAddress', body, true);
    return seq
  }

  savePM(data) {
    var body = {
      "addressLine1": this.toUpperCase(data.addressLine1),
      "addressLine2": this.toUpperCase(data.addressLine2),
      "cardHolderNbr": data.cardHolderNbr?data.cardHolderNbr:0,
      "cardHolderType": "P",
      "cardHolderDocuments": data.cardHolderDocuments,
      "cityName": data.cityName,
      "countryCode": "IN",
      "countyName": data.countyName,
      "dateOfBirth": data.dateOfBirth,
      "educationDetail": data.educationDetail? this.toUpperCase(data.educationDetail):"",
      "email": data.email? this.toUpperCase(data.email):"",
      "firstName": this.toUpperCase(data.firstName),
      "householdIncome": data.householdIncome?data.householdIncome:"",
      "isBusinessOwner": data.isBusinessOwner,
      "landlineNbr": data.landlineNbr?data.landlineNbr:null,
      "lastName": this.toUpperCase(data.lastName),
      "maMembershipId": this.mlid,
      "membershipNbr": this.mid,
      "middleName": data.middleName? this.toUpperCase(data.middleName):"",
      "phoneNbr": data.phoneNbr,
      "photoTypeCode": data.photoTypeCode,
      "postalCode": data.postalCode,
      "relationship": data.relationship? this.toUpperCase(data.relationship):"",
      "socialHandles": data.socialHandles? this.toUpperCase(data.socialHandles):"",
      "stateProvCode": data.stateProvCode,
      "status": data.status?data.status:"A",
      "whatsappNbr": data.whatsappNbr?data.whatsappNbr:null,
      "photoIdStateCode": data.photoIdStateCode,
      "photoIdNbr": data.photoIdNbr,
      "expirationDt": data.expirationDt
    }
    let seq = this.api.post('bp/v1/savePrimaryMemberInfo', body, true);
    return seq
  }

  saveAM(data) {
    var body = {
      "addressLine1": this.toUpperCase(data.addressLine1),
      "addressLine2": this.toUpperCase(data.addressLine2),
      "cardHolderNbr": data.cardHolderNbr?data.cardHolderNbr:0,
      "cardHolderType": "A",
      "cardHolderDocuments": data.cardHolderDocuments,
      "cityName": data.cityName,
      "countryCode": "IN",
      "countyName": data.countyName,
      "dateOfBirth": data.dateOfBirth,
      "educationDetail": data.educationDetail? this.toUpperCase(data.educationDetail):"",
      "email": data.email? this.toUpperCase(data.email):"",
      "firstName": this.toUpperCase(data.firstName),
      "householdIncome": data.householdIncome?data.householdIncome:"",
      "isBusinessOwner": data.isBusinessOwner,
      "landlineNbr": data.landlineNbr?data.landlineNbr:null,
      "lastName": this.toUpperCase(data.lastName),
      "maMembershipId": this.mlid,
      "membershipNbr": this.mid,
      "middleName": data.middleName? this.toUpperCase(data.middleName):"",
      "phoneNbr": data.phoneNbr,
      "photoTypeCode": this.toUpperCase(data.photoTypeCode),
      "postalCode": data.postalCode,
      "relationship": this.toUpperCase(data.relationship),
      "socialHandles": data.socialHandles? this.toUpperCase(data.socialHandles):"",
      "stateProvCode": data.stateProvCode,
      "status": data.status?data.status:"A",
      "whatsappNbr": data.whatsappNbr?data.whatsappNbr:null,
      "photoIdStateCode": data.photoIdStateCode,
      "photoIdNbr": data.photoIdNbr,
      "expirationDt": data.expirationDt
    }
    let seq = this.api.post('bp/v1/saveAddOnMemberInfo', body, true);
    return seq
  }

  saveContact(id,phone,email) {
    let body = {
      "maMembershipId": this.mlid,
      "membershipNbr": this.mid,
      "cardHolderNbr": id,
      "email": email,
      "phoneNbr": phone
    }
    let seq = this.api.post('bp/v1/updateAddOnMember',body, true);
    return seq
  }

  updateCardStatus(cid) {
    var body = {
      "cardHolderNbr": cid,
      "membershipNbr": this.mid,
      "status": "A"
    }
    let seq = this.api.post('bp/v1/updateCardStatus', body, true);
    return seq
  }

  updateContact(data) {
    let body: any = data;
    body.maMembershipId = this.mlid;
    body.membershipNbr = this.mid;
    body.status = this.mstatus;
    let seq = this.api.post('bp/v1/changePhoneNumberRequest', body);
    return seq
  }
 
  mobileNumberUpdate(data) {
    let body: any = data;
    body.maMembershipId = this.mlid;
    body.membershipNbr = this.mid;
    let seq = this.api.post('bp/v1/updateCardHolderPhoneNbr', body, true);
    return seq
  }


  revokeMember(data) {
    data.maMembershipId = this.mlid;
    let seq = this.api.post('bp/v1/revokeMembership', data, true);
    return seq
  }
  
  revokePrimary(data) {
    data.maMembershipId = this.mlid;
    data.membershipNbr = this.mid;
    data.status = "R";
    if(data.businessInfoParams != null) {
      data.businessInfoParams.maMembershipId = this.mlid;
      data.businessInfoParams.membershipNbr = this.mid;
      data.businessInfoParams.status = this.mstatus;
    }
    data.cardHolderInfo.maMembershipId = this.mlid;
    data.cardHolderInfo.membershipNbr = this.mid;
    let seq = this.api.post('bp/v1/revokePrimaryCard', data, true);
    return seq
  }
  
  submitMember() {
    let seq = this.api.post('bp/v1/submitMembershipApplication', { "maMembershipId": this.mlid, "membershipNbr": this.mid, "status": "DRAFT" }, true);
    return seq
  }
  
  populateForm() {
    let seq = this.api.post('bp/v1/getMembershipInfo', { "maMembershipId": this.mlid, "membershipNbr": this.mid, "status": this.mstatus }, true);
    return seq
  }

  confirmEdit() {
    let seq = this.api.post('bp/v1/submitMembershipForUpdate', { "maMembershipId": this.mlid, "membershipNbr": this.mid, "status": this.mstatus }, true);
    return seq
  }

 
  toUpperCase(text) {
    return text != null ? text.toUpperCase() : text;
  }
}
